



















import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import LearningRequestFormCreateV2 from "@/components/learning-request-v2/LearningRequestFormCreateV2.vue";
import { learningRequestApi } from "@/getinfo-api";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import { LearningRequestCreate as ILearningRequestCreate } from "@/api-v2/learning-requests/models";
import { cloneDeep } from "lodash";
import { nextSequence } from "@/utils/generate-helper";

@Component({ components: { CPageButtons, LearningRequestFormCreateV2, CPage } })
export default class LearningRequestCreateV2 extends Vue {
  learningRequestForm!: ILearningRequestCreate;
  isLoading: boolean = false;

  data() {
    return {
      learningRequestForm: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "orders" },
        label: `${this.$tc(this.$translate.LearningRequests)}`
      },
      {
        label: this.$tc(this.$translate.Create)
      }
    ];
  }

  async checkQuery() {
    const requestIdForCopy = this.$route?.query?.byOrder;

    if (requestIdForCopy && typeof requestIdForCopy === "string") {
      await this.getRequest(requestIdForCopy!);
    }
  }

  async getRequest(id: string) {
    try {
      this.isLoading = true;
      const { data } = await learningRequestApi.Request.getRequest(id);
      this.learningRequestForm = cloneDeep(data);
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  async createLearningRequest() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    this.isLoading = true;
    let form = cloneDeep(this.learningRequestForm);
    form.price = this.$converter.setPrice(form.price);
    learningRequestApi.Request.createRequest(form)
      .then(async res => {
        await nextSequence();
        await this.$router.push({
          name: "learningRequest",
          params: {
            id: res.data.id
          }
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  back() {
    this.$router.push({
      name: "orders"
    });
  }

  created() {
    this.checkQuery();
  }
}
